import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin: 0;

  li {
    width: 80%;
    border: none;
  }
`;

export const ContainerAnswers = styled.ul`
  width: 100%;
  margin: 0;

  li {
    width: 80%;
  }
`;

export const ContainerForm = styled.div`
  width: 80%;
  margin: 0 auto;
`;
